export default {
  projectId: '',
  districtId: '',
  lang: '',
  uuid: '',
  runsOn: 'mobile',
  accountId: undefined,
  isPreview: false,
  appStage: '',
  kidsData: '',
  learningModulesRedux: [],
  rrGameOnly: false,
  appVersion: '18.0.0',
  apiGWPrefix: '',
  dzBrandConfigs: {}
};
